export const jfcVsMcfMatch = {
  _id: '63cb03286bc8d3ddb965e21b',
  apiMatchId: '174289',
  awayTeam: {
    tid: '458',
    tname: 'Mumbai City',
    logo: 'https://soccer.entitysport.com/assets/team/458.png',
    fullname: 'Mumbai City FC',
    abbr: 'MCFC'
  },
  competition: {
    cid: '872',
    cname: 'Indian Super League',
    startdate: '2022-10-07 00:00:00',
    enddate: '2023-03-31 00:00:00',
    startdatetimestamp: '1665100800',
    endtdatetimestamp: '1680220800',
    year: '22/23',
    category: 'India',
    tournament_id: '16',
    category_id: '14',
    ioc: 'in',
    status: '3',
    status_str: 'live',
    logo: ''
  },
  createdOn: '2023-01-20T21:10:00.474Z',
  endDate: '2023-01-27T21:00:00.000Z',
  formatString: 'Indian Super League',
  gameState: 1,
  gameStateText: 'Not started',
  homeTeam: {
    tid: '460',
    tname: 'Jamshedpur',
    logo: 'https://soccer.entitysport.com/assets/team/460.png',
    fullname: 'Jamshedpur FC',
    abbr: 'JFC'
  },
  lineupsOut: false,
  modifiedOn: '2023-01-27T02:57:00.307Z',
  preSquad: true,
  result: {
    home: '0',
    away: '0',
    winner: ''
  },
  round: '17',
  startDate: '2023-01-27T14:00:00.000Z',
  status: 1,
  statusText: 'upcoming',
  timestampEnd: 1674853200,
  timestampStart: 1674828000,
  title: 'Jamshedpur vs Mumbai City',
  venue: {
    venueid: '442',
    name: 'JRD Tata Sports Complex Stadium',
    location: 'Jamshedpur, India',
    founded: '1991',
    capacity: '60000',
    googlecoords: '22.806022,86.193536'
  },
  verified: false,
  isContestListed: true
};
export const atkVsOdiMatch = {
  _id: '63cda4c06bc8d3ddb9c91f39',
  apiMatchId: '174291',
  awayTeam: {
    tid: '454',
    tname: 'Odisha',
    logo: 'https://soccer.entitysport.com/assets/team/454.png',
    fullname: 'Odisha FC',
    abbr: 'ODI'
  },
  competition: {
    cid: '872',
    cname: 'Indian Super League',
    startdate: '2022-10-07 00:00:00',
    enddate: '2023-03-31 00:00:00',
    startdatetimestamp: '1665100800',
    endtdatetimestamp: '1680220800',
    year: '22/23',
    category: 'India',
    tournament_id: '16',
    category_id: '14',
    ioc: 'in',
    status: '3',
    status_str: 'live',
    logo: ''
  },
  createdOn: '2023-01-22T21:04:00.332Z',
  endDate: '2023-01-28T21:00:00.000Z',
  formatString: 'Indian Super League',
  gameState: 1,
  gameStateText: 'Not started',
  homeTeam: {
    tid: '2029',
    tname: 'ATK Mohun Bagan',
    logo: 'https://soccer.entitysport.com/assets/team/2029.png',
    fullname: 'ATK Mohun Bagan',
    abbr: 'ATKMB'
  },
  lineupsOut: false,
  modifiedOn: '2023-01-27T12:02:00.512Z',
  preSquad: true,
  result: {
    home: '0',
    away: '0',
    winner: ''
  },
  round: '17',
  startDate: '2023-01-28T14:00:00.000Z',
  status: 1,
  statusText: 'upcoming',
  timestampEnd: 1674939600,
  timestampStart: 1674914400,
  title: 'ATK Mohun Bagan vs Odisha',
  venue: {
    venueid: '1022',
    name: 'Vivekananda Yuba Bharati Krirangan',
    location: 'Kolkata, India',
    founded: '',
    capacity: '120000',
    googlecoords: '22.568889,88.409167'
  },
  verified: false,
  isContestListed: true
};
export const kerVsNorMatch = {
  _id: '63d29ad46bc8d3ddb9782e01',
  apiMatchId: '174292',
  awayTeam: {
    tid: '459',
    tname: 'Northeast Utd',
    logo: 'https://soccer.entitysport.com/assets/team/459.png',
    fullname: 'Northeast United FC',
    abbr: 'NOR'
  },
  competition: {
    cid: '872',
    cname: 'Indian Super League',
    startdate: '2022-10-07 00:00:00',
    enddate: '2023-03-31 00:00:00',
    startdatetimestamp: '1665100800',
    endtdatetimestamp: '1680220800',
    year: '22/23',
    category: 'India',
    tournament_id: '16',
    category_id: '14',
    ioc: 'in',
    status: '3',
    status_str: 'live',
    logo: ''
  },
  createdOn: '2023-01-26T15:23:00.329Z',
  endDate: '2023-01-29T21:00:00.000Z',
  formatString: 'Indian Super League',
  gameState: 1,
  gameStateText: 'Not started',
  homeTeam: {
    tid: '457',
    tname: 'Kerala',
    logo: 'https://soccer.entitysport.com/assets/team/457.png',
    fullname: 'Kerala Blasters FC',
    abbr: 'KER'
  },
  lineupsOut: false,
  modifiedOn: '2023-01-27T03:11:00.455Z',
  preSquad: true,
  result: {
    home: '0',
    away: '0',
    winner: ''
  },
  round: '17',
  startDate: '2023-01-29T14:00:00.000Z',
  status: 1,
  statusText: 'upcoming',
  timestampEnd: 1675026000,
  timestampStart: 1675000800,
  title: 'Kerala vs Northeast Utd',
  venue: {
    venueid: '439',
    name: 'Jawaharlal Nehru Stadium',
    location: 'Kochi, India',
    founded: '',
    capacity: '60000',
    googlecoords: '9.997253,76.301036'
  },
  verified: false,
  isContestListed: true
};
export const atkVsCfcMatch = {
  _id: '633ec64c746a9884af15dc05',
  apiMatchId: '174211',
  awayTeam: {
    tid: '453',
    tname: 'Chennaiyin',
    logo: 'https://soccer.entitysport.com/assets/team/453.png',
    fullname: 'Chennaiyin FC',
    abbr: 'CHE'
  },
  competition: {
    cid: '872',
    cname: 'Indian Super League',
    startdate: '2022-10-07 00:00:00',
    enddate: '2023-03-31 00:00:00',
    startdatetimestamp: '1665100800',
    endtdatetimestamp: '1680220800',
    year: '22/23',
    category: 'India',
    tournament_id: '16',
    category_id: '14',
    ioc: 'in',
    status: '3',
    status_str: 'live',
    logo: ''
  },
  createdOn: '2022-10-06T12:13:00.480Z',
  endDate: '2022-10-10T16:05:55.000Z',
  formatString: 'Indian Super League',

  homeTeam: {
    tid: '2029',
    tname: 'ATK Mohun Bagan',
    logo: 'https://soccer.entitysport.com/assets/team/2029.png',
    fullname: 'ATK Mohun Bagan',
    abbr: 'ATKMB'
  },
  lineupsOut: true,
  modifiedOn: '2022-10-10T19:28:01.411Z',
  preSquad: true,
  result: {
    home: '1',
    away: '2',
    winner: 'away'
  },
  round: '1',
  startDate: '2022-10-10T14:00:00.000Z',
  status: 3,
  statusText: 'live',
  gameState: 3,
  gameStateText: 'Half time',
  timestampEnd: 1665417955,
  timestampStart: 1665410400,
  title: 'ATK Mohun Bagan vs Chennaiyin',
  venue: {
    venueid: '1022',
    name: 'Vivekananda Yuba Bharati Krirangan',
    location: 'Kolkata, India',
    founded: '',
    capacity: '120000',
    googlecoords: '22.568889,88.409167'
  },
  verified: false,
  isContestListed: true
};
export const kfcVsNeUtdMatch = {
  _id: '63d29ad46bc8d3ddb9782e01',
  apiMatchId: '174292',
  awayTeam: {
    tid: '459',
    tname: 'Northeast Utd',
    logo: 'https://soccer.entitysport.com/assets/team/459.png',
    fullname: 'Northeast United FC',
    abbr: 'NOR'
  },
  competition: {
    cid: '872',
    cname: 'Indian Super League',
    startdate: '2022-10-07 00:00:00',
    enddate: '2023-03-31 00:00:00',
    startdatetimestamp: '1665100800',
    endtdatetimestamp: '1680220800',
    year: '22/23',
    category: 'India',
    tournament_id: '16',
    category_id: '14',
    ioc: 'in',
    status: '3',
    status_str: 'live',
    logo: ''
  },
  createdOn: '2023-01-26T15:23:00.329Z',
  endDate: '2023-01-29T21:00:00.000Z',
  formatString: 'Indian Super League',
  gameState: 1,
  gameStateText: 'Not started',
  homeTeam: {
    tid: '457',
    tname: 'Kerala',
    logo: 'https://soccer.entitysport.com/assets/team/457.png',
    fullname: 'Kerala Blasters FC',
    abbr: 'KER'
  },
  lineupsOut: false,
  modifiedOn: '2023-01-27T12:02:00.513Z',
  preSquad: true,
  result: {
    home: '0',
    away: '0',
    winner: ''
  },
  round: '17',
  startDate: '2023-01-29T14:00:00.000Z',
  status: 1,
  statusText: 'upcoming',
  timestampEnd: 1675026000,
  timestampStart: 1675000800,
  title: 'Kerala vs Northeast Utd',
  venue: {
    venueid: '439',
    name: 'Jawaharlal Nehru Stadium',
    location: 'Kochi, India',
    founded: '',
    capacity: '60000',
    googlecoords: '9.997253,76.301036'
  },
  verified: false,
  isContestListed: true
};
